import trendingWinnersSagas from './lineups/sagas'

const sagas = () => [...trendingWinnersSagas()]
export default sagas
